// @import dependencies
import React, {Component, CSSProperties} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {BuyCourseModuleLayout} from 'app_components/modules/academic/buyCourse'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import { ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @ADD Component types
interface IBuyCourseModuleProps {
  course: ICourse | null
  coursesToRender: ICourse[]
  className?: string
  style?: CSSProperties
  setCurrentCourse: (course: ICourse) => void
}
interface IBuyCourseModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class BuyCourseModule extends Component<IBuyCourseModuleProps, IBuyCourseModuleState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IBuyCourseModuleProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <BuyCourseModuleLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(BuyCourseModule)
